import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, PageHeader } from '@jordan/ui';
import { AppChrome } from '../../components/AppChrome';
import { billingTimeSidebar } from './billingTimeSidebar';

/** Placeholder page for a Billing & Time sub-section that isn't built out yet. */
export function BillingTimeStubPage({ title, icon }: { title: string; icon: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <AppChrome secondarySidebar={billingTimeSidebar(navigate, pathname)}>
      <PageHeader
        title={
          <>
            Billing &amp; Time - <span className="fw-normal">{title}</span>
          </>
        }
        breadcrumb={
          <Breadcrumb
            items={[
              { icon: 'ph-house', href: '/' },
              { label: 'Consulting' },
              { label: 'Billing & Time' },
              { label: title },
            ]}
          />
        }
      />
      <div className="content">
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center text-muted py-5">
            <i className={`${icon} d-block fs-1 mb-2`} />
            <h5 className="mb-1">{title}</h5>
            <p className="mb-0">This section is coming soon.</p>
          </div>
        </div>
      </div>
    </AppChrome>
  );
}
